import { createComponent } from '@carvana/merch-components';

export const BodyType = createComponent('p', {
  className: 'text-text-strong t-heading-sm'
});

export const Price = createComponent('strong', {
  className: 'text-text-strong t-heading-xl'
});

export const Inventory = createComponent('p', {
  className: 'text-text-default t-body-sm'
});
